import { render, staticRenderFns } from "./EditComboBoxItem.vue?vue&type=template&id=8cfbda32"
import script from "./EditComboBoxItem.vue?vue&type=script&lang=ts"
export * from "./EditComboBoxItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports